import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./fr.json";
import ar from "./ar.json";

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      ar: { translation: ar },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "ar"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "cookie", "navigator"],
      caches: ["cookie"],
      cookieMinutes: 60 * 24 * 365,
    },
  });

// Apply <html lang/dir> for a resolved language. Used for BOTH runtime toggles
// (languageChanged) AND the initial detected language. i18next does NOT emit
// languageChanged for the language detected during init(), so without the
// `initialized` hook a returning Arabic user (cached `i18next=ar` cookie), an
// `?lng=ar` deep link, or an `ar` navigator would render Arabic content in an
// LTR layout (dir never set). Use startsWith to tolerate region codes (ar-MA).
function applyDocumentDirection(lng: string | undefined) {
  const resolved = lng ?? "fr";
  document.documentElement.lang = resolved;
  document.documentElement.dir = resolved.startsWith("ar") ? "rtl" : "ltr";
}

i18next.on("languageChanged", applyDocumentDirection);
i18next.on("initialized", () => {
  applyDocumentDirection(i18next.resolvedLanguage ?? i18next.language);
});

// With inline `resources` (no async backend) i18next.init() resolves
// SYNCHRONOUSLY and emits `initialized` *during* the init() call above —
// before the listener we just attached could catch it. So apply the initial
// direction directly here as well (the listeners cover any future async path).
if (i18next.isInitialized) {
  applyDocumentDirection(i18next.resolvedLanguage ?? i18next.language);
}

export default i18next;
